import {
    ArraySchemaElement,
    HiddenSchemaElement,
    SchemaElement,
    SchemaElementType,
    TabSchemaElement,
    WidgetConfiguration,
} from './types';
import { parseArraySchemaDefaults } from './arrayParser';
import { buildSettingsDefaults } from './buildSetting';
import { parseTabSchemaDefaults } from './tabParser';

export function generateWidgetConfiguration(schema: (TabSchemaElement|ArraySchemaElement|HiddenSchemaElement)[]) {
    let configuration: WidgetConfiguration = {};
    schema.forEach((schemaElement: SchemaElement) => {
        if (schemaElement.type === SchemaElementType.TAB) {
            const tabSchemaElement = schemaElement as TabSchemaElement;
            const tabSectionDefaults = parseTabSchemaDefaults(tabSchemaElement.sections);
            configuration = {
                ...configuration,
                ...tabSectionDefaults,
            };
        }

        if (schemaElement.type === SchemaElementType.ARRAY) {
            const arraySchemaElement = schemaElement as ArraySchemaElement;
            const arraySectionDefaults = parseArraySchemaDefaults(arraySchemaElement);

            configuration = {
                ...configuration,
                ...arraySectionDefaults,
            };
        }

        if (schemaElement.type === SchemaElementType.HIDDEN) {
            const hiddenSchemaElement = schemaElement as HiddenSchemaElement;
            const hiddenSettingDefaults = buildSettingsDefaults(hiddenSchemaElement.settings);

            configuration = {
                ...configuration,
                ...hiddenSettingDefaults,
            };
        }
    });

    return configuration;
}
